export const collapseAnimationDuration = "250ms";
export const collapseAnimationEasing = "ease-out";
